// @flow

import { type Pin } from 'app/common/react/components/PinRep/types';

export default function getImageUrl(imagesObj: $PropertyType<Pin, 'images'>, imageSize: string) {
  return imagesObj && imagesObj[imageSize] && imagesObj[imageSize].url;
}
